// Hybrid: `group` is the group handle. Legacy: `groupHandle` is the handle (`group` is a display name).

const EVIDENSIA_HANDLE = 'evidensia'
export const EVIDENSIA_LOGO_SRC = 'https://cdn.heiland.com/gpo-images/evidensia.png'

export type EvidensiaAccentColor = 'success-dark' | 'heiland-orange'

const EVIDENSIA_GROUP_COLOR: Record<string, EvidensiaAccentColor> = {
  'evidensia-tier-1': 'success-dark',
  'evidensia-tier-2': 'heiland-orange',
}

export const GPO_CHIP_LABEL_KEY_PREFIX = 'gpo.chip'

export interface GpoChipClinicChain {
  handle: string
  name: string
  color?: string | null
  /** Hybrid: group handle. Legacy: unused display name. */
  group?: string | null
  /** Legacy: group handle. Hybrid: absent. */
  groupHandle?: string | null
}

export interface ResolvedGpoChip {
  show: boolean
  color?: string
  variant: 'flat' | 'tonal'
  /** Set when the product has a GPO classification. */
  labelKey?: string
  showName: boolean
  logoSrc?: string
  /** Theme token for the add-to-cart left accent; only set for classified Evidensia. */
  accentColor?: EvidensiaAccentColor
}

export const resolveGpoChip = (chain?: GpoChipClinicChain | null): ResolvedGpoChip => {
  if (!chain) {
    return { show: false, variant: 'tonal', showName: true }
  }

  // Legacy always includes `groupHandle` (null = unclassified). Hybrid omits it.
  const groupKey = chain.groupHandle !== undefined
    ? (chain.groupHandle ?? undefined)
    : (chain.group ?? undefined)
  const evidensiaColor = groupKey ? EVIDENSIA_GROUP_COLOR[groupKey] : undefined
  const isEvidensiaClassified = chain.handle === EVIDENSIA_HANDLE && evidensiaColor !== undefined
  const color = isEvidensiaClassified ? evidensiaColor : (chain.color ?? undefined)

  return {
    show: true,
    color,
    variant: color ? 'flat' : 'tonal',
    labelKey: groupKey ? `${GPO_CHIP_LABEL_KEY_PREFIX}.${groupKey}` : undefined,
    showName: !isEvidensiaClassified,
    logoSrc: isEvidensiaClassified ? EVIDENSIA_LOGO_SRC : undefined,
    accentColor: isEvidensiaClassified ? evidensiaColor : undefined,
  }
}

export const gpoAccentClass = (chain?: GpoChipClinicChain | null): string | undefined => {
  const accentColor = resolveGpoChip(chain).accentColor
  return accentColor ? `vmz-btn-add-to-cart--gpo-${accentColor}` : undefined
}
